var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("app-mobile-full-screen-container", [
    _c(
      "div",
      { staticClass: "w100" },
      [
        _c("w-breadcrumb", { attrs: { crumbs: _vm.path } }),
        _c(
          "w-scroll-view",
          { attrs: { tag: "w-container" } },
          [
            _c(
              "w-row",
              [
                _c(
                  "w-col",
                  { attrs: { sm: "12", md: "6" } },
                  [
                    _c(
                      "w-card",
                      [
                        _c("w-card-title", [
                          _vm._v(
                            " " + _vm._s(_vm.$ct("common.settings")) + " "
                          ),
                        ]),
                        _c(
                          "w-card-content",
                          [
                            _c("w-checkbox", {
                              attrs: { label: _vm.$ct("auto-shop-synch") },
                              model: {
                                value: _vm.allow,
                                callback: function ($$v) {
                                  _vm.allow = $$v
                                },
                                expression: "allow",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "w-card-actions",
                          [
                            _c("w-spacer"),
                            _c(
                              "w-button",
                              {
                                attrs: { disabled: !_vm.hasModule },
                                on: {
                                  click: function ($event) {
                                    return _vm.save()
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$ct("common.save")))]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }